import defaultImage from "./../../asset/image/ex_img_3.png";
import dateIcon from "./../../asset/icons/calender_gray_s.svg";
import feedCoin from "./../../asset/icons/rate_ic.svg";
import starIcon from "./../../asset/icons/starIcon.svg";
import {DELETE_MARKET_BASKET, GET_MARKET_BASKET,} from "../../helperData/ApiAddress";
import {useEffect, useState} from "react";
import {del, get} from "../../controlers/global/ConfigRequest";
import PaginationComponent from "../../component/global/PaginationComponent";
import {Spinner} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function Basket() {
  const history = useNavigate();
  const [basket, setBasket] = useState(undefined);
  const [page, setPage] = useState("1");
  const [deleteLoader, setDeleteLoader] = useState(false);
  const {t} = useTranslation();

  const getBasket = () => {
    const url = new URL(GET_MARKET_BASKET);
    url.searchParams.set("page", page);

    get(url).then((r) => {
      setBasket(r);
    });
  };
  useEffect(getBasket, [page]);

  const basketDeleteHandle = (id) => {
    setDeleteLoader(id);
    del(DELETE_MARKET_BASKET.replace(":id", id))
      .then((r) => {
        getBasket();
      })
      .finally((_) => {
        setDeleteLoader(false);
      });
  };

  return (
    <div className="basket-section">
      <div className="basket-table">
        <div className="header">
          <div>&nbsp;</div>
          <div>{t("Organizational.SellingBasket.Product.Label")}</div>
          <div>
            {t("Organizational.SellingBasket.Organization.Label")}
          </div>
          <div>
            {t(
              "Organizational.SellingBasket.RegistrationDate.Label"
            )}
          </div>
          <div>{t("Organizational.SellingBasket.Plans.Label")}</div>
          <div>
            {t("Organizational.SellingBasket.FeedCoin.Label")}
          </div>
          <div>{t("Organizational.SellingBasket.Points.Label")}</div>
          <div>
            {t("Organizational.SellingBasket.Functions.Label")}
          </div>
        </div>
        {basket ? (
          basket.results.length > 0 ? (
            basket.results.map((item, index) => (
              <div key={index}>
                <div>
                  <img
                    className="preview"
                    src={defaultImage}
                    alt=""
                  />
                </div>
                <div>{item.item.name}</div>
                <div>{item.company.name}</div>
                <div>
                  <img src={dateIcon} alt=""/>
                  <span>1400/12/12</span>
                </div>
                <div>4</div>
                <div>
                  <img src={feedCoin} alt=""/>
                  <span>{item.coin}</span>
                </div>
                <div>
                  <img src={starIcon} alt=""/>
                  <span>
                    {(Math.round(item.item.computed_score * 10) / 10).toString().replace(".", "/")}
                  </span>
                </div>
                <div>
                  <button
                    className="button primary"
                    onClick={(_) =>
                        history("/dashboard/market/form/" + item.id)
                    }
                  >
                    {t("Organizational.SellingBasket.Edit")}
                  </button>
                  <button
                    className="button delete"
                    onClick={(_) => basketDeleteHandle(item.id)}
                  >
                    {deleteLoader === item.id ? (
                      <div className="spinner-border-con">
                        <Spinner animation="border"/>
                      </div>
                    ) : (
                      <div>
                        {t("Organizational.SellingBasket.Remove")}
                      </div>
                    )}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <span className="empty-basket">
              {t("Organizational.SellingBasket.Not.Found.Title")}
            </span>
          )
        ) : (
          <Spinner animation="border"/>
        )}
      </div>

      {basket?.count > 20 && (
        <PaginationComponent
          currentPage={page - 1}
          pageCount={Math.ceil(basket.count / 20)}
          fetchData={(e) => setPage(e.pageIndex + 1)}
          feedbacks={basket.results}
        />
      )}
    </div>
  );
}
